module.exports = __webpack_public_path__ + "media/images/sponsorBox__bg-0398e88bd55274dc81c7894c1f9e5ef5.jpg";